/**
 * FILE: assets/shop-by-vehicle.js
 *
 * Powers the "Shop by Vehicle" section (sections/shop-by-vehicle.liquid).
 *
 * Reads the shared fitment database (window.YLGarageConfig.fitment, injected by the
 * header garage) for the section's model, groups the years into generations (contiguous
 * years that share the same variant set, newest first), and fills each server-rendered
 * row: generation name + year range + the Pro/OG product cards' variant links. A product
 * with no variant for that generation is dimmed with a "Not available" badge.
 *
 * Rows come from Liquid blocks (one per generation, newest first); this only hydrates
 * them — labels, links, availability. Extra rows (no matching generation) are hidden.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Distinct, non-null values, preserving order.
  function distinct(arr) {
    var seen = {}, out = [];
    arr.forEach(function (x) { if (x != null && x !== '' && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  // A generation boundary is where the full option->(pro,og) set changes.
  function signature(entries) {
    return entries.map(function (e) { return e.o + '|' + (e.pro || '') + '|' + (e.og || ''); }).sort().join('~');
  }

  // Group a model's { year: [entries] } into generations, newest first.
  function deriveGenerations(byYear) {
    var years = Object.keys(byYear).map(Number).sort(function (a, b) { return b - a; });
    var gens = [], cur = null;
    years.forEach(function (y) {
      var entries = byYear[String(y)] || [];
      var sig = signature(entries);
      if (cur && cur.sig === sig) {
        cur.min = Math.min(cur.min, y);
        cur.max = Math.max(cur.max, y);
      } else {
        cur = { sig: sig, entries: entries, min: y, max: y };
        gens.push(cur);
      }
    });
    return gens;
  }

  function applyCard(card, variants, url, naLabel) {
    if (!card) return;
    var na = card.querySelector('.sbv__na');
    if (variants.length && url) {
      // A generation with sub-options links to a representative variant; the shopper
      // finishes the sub-option choice on the product page.
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      card.href = url + sep + 'variant=' + encodeURIComponent(variants[0]);
      card.classList.remove('vg__card--disabled');
      card.removeAttribute('aria-disabled');
      if (na) na.parentNode.removeChild(na);
    } else {
      card.removeAttribute('href');
      card.classList.add('vg__card--disabled');
      card.setAttribute('aria-disabled', 'true');
      if (!na) {
        na = document.createElement('span');
        na.className = 'sbv__na';
        na.textContent = naLabel || 'Not available';
        card.appendChild(na);
      }
    }
  }

  ready(function () {
    var cfg = window.YLGarageConfig || {};
    var fitment = cfg.fitment || {};

    document.querySelectorAll('.sbv').forEach(function (root) {
      var model = root.getAttribute('data-model');
      var proUrl = root.getAttribute('data-pro-url') || '';
      var ogUrl = root.getAttribute('data-og-url') || '';
      var naLabel = root.getAttribute('data-unavailable') || 'Not available';
      var grid = root.querySelector('.sbv__grid');
      var empty = root.querySelector('.sbv__empty');
      var byYear = fitment[model];

      if (!byYear || !Object.keys(byYear).length) {
        if (grid) grid.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }

      var gens = deriveGenerations(byYear);
      var total = gens.length;
      var rows = grid ? grid.querySelectorAll('.sbv__row') : [];

      Array.prototype.forEach.call(rows, function (row, i) {
        var gen = gens[i];
        if (!gen) { row.hidden = true; return; }
        row.hidden = false;

        var nameOverride = (row.getAttribute('data-name') || '').trim();
        var yearOverride = (row.getAttribute('data-year-label') || '').trim();
        var gEl = row.querySelector('.sbv__gen');
        var yEl = row.querySelector('.sbv__years');
        if (gEl) gEl.textContent = nameOverride || (ordinal(total - i) + ' Gen');
        if (yEl) yEl.textContent = yearOverride || (gen.min === gen.max ? String(gen.min) : gen.min + ' – ' + gen.max);

        var proVars = distinct(gen.entries.map(function (e) { return e.pro; }));
        var ogVars = distinct(gen.entries.map(function (e) { return e.og; }));
        var products = row.querySelector('.sbv__products');
        var soon = row.querySelector('.sbv__soon');

        // A generation with neither Pro nor OG shows one "coming soon" note, not two dead cards.
        if (!proVars.length && !ogVars.length) {
          if (products) products.hidden = true;
          if (soon) soon.hidden = false;
        } else {
          if (products) products.hidden = false;
          if (soon) soon.hidden = true;
          applyCard(row.querySelector('.vg__card[data-kind="pro"]'), proVars, proUrl, naLabel);
          applyCard(row.querySelector('.vg__card[data-kind="og"]'), ogVars, ogUrl, naLabel);
        }
      });
    });
  });
})();
